// extracted by mini-css-extract-plugin
export default {"yearInput":"CalendarTitle__yearInput___dNt0K","datePicker":"CalendarTitle__datePicker___QBdzd","title":"CalendarTitle__title___rpWbU","disabled":"CalendarTitle__disabled___TZcES"};